import { EventObject } from "../../util/event/EventObject";
/*
 * FocusEvent.ts
 */
export class GameFocusEvent {
}
GameFocusEvent.OUT = new EventObject("FocusChangedEvent.OUT");
GameFocusEvent.IN = new EventObject("FocusChangedEvent.IN");
//# sourceMappingURL=FocusEvent.js.map